import { useQuery } from "@tanstack/react-query";

import { ListSectorsQueryFilters, UseListSectorsQueryOptions } from "./types";
import { getSectorsService  } from "./service";

export const listSectorsQueryKey = ["book_sector_admin"];

export function useListSectorsQuery(
  filters?: ListSectorsQueryFilters,
  options?: UseListSectorsQueryOptions
) {
  const queryKey = listSectorsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getSectorsService(filters),
    ...options,
  });
}
